/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_Open_Link_NewInputs */

const en_btn_open_link_new = /** @type {(inputs: Btn_Open_Link_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open link in new tab`)
};

const ar_btn_open_link_new = /** @type {(inputs: Btn_Open_Link_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فتح الرابط في تبويب جديد`)
};

const bn_btn_open_link_new = /** @type {(inputs: Btn_Open_Link_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`নতুন ট্যাবে লিংক খুলুন`)
};

const de_btn_open_link_new = /** @type {(inputs: Btn_Open_Link_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link in neuem Tab öffnen`)
};

const es_btn_open_link_new = /** @type {(inputs: Btn_Open_Link_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir enlace en una pestaña nueva`)
};

const fr_btn_open_link_new = /** @type {(inputs: Btn_Open_Link_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrir le lien dans un nouvel onglet`)
};

const pt_btn_open_link_new = /** @type {(inputs: Btn_Open_Link_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir link em uma nova guia`)
};

const zh_btn_open_link_new = /** @type {(inputs: Btn_Open_Link_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在新选项卡中打开链接`)
};

const tr_btn_open_link_new = /** @type {(inputs: Btn_Open_Link_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bağlantıyı yeni sekmede aç`)
};

const ru_btn_open_link_new = /** @type {(inputs: Btn_Open_Link_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Открыть ссылку в новой вкладке`)
};

const pl_btn_open_link_new = /** @type {(inputs: Btn_Open_Link_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otwórz link w nowej karcie`)
};

/**
* | output |
* | --- |
* | "Open link in new tab" |
*
* @param {Btn_Open_Link_NewInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const btn_open_link_new = /** @type {((inputs?: Btn_Open_Link_NewInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_Open_Link_NewInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_btn_open_link_new(inputs)
	if (locale === "bn") return bn_btn_open_link_new(inputs)
	if (locale === "de") return de_btn_open_link_new(inputs)
	if (locale === "es") return es_btn_open_link_new(inputs)
	if (locale === "fr") return fr_btn_open_link_new(inputs)
	if (locale === "pt") return pt_btn_open_link_new(inputs)
	if (locale === "zh") return zh_btn_open_link_new(inputs)
	if (locale === "tr") return tr_btn_open_link_new(inputs)
	if (locale === "ru") return ru_btn_open_link_new(inputs)
	if (locale === "pl") return pl_btn_open_link_new(inputs)
	return en_btn_open_link_new(inputs)
});